import { render, staticRenderFns } from "./SoundRecordingDetailPage.vue?vue&type=template&id=43508595&scoped=true&"
import script from "./SoundRecordingDetailPage.vue?vue&type=script&lang=js&"
export * from "./SoundRecordingDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./SoundRecordingDetailPage.vue?vue&type=style&index=0&id=43508595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43508595",
  null
  
)

export default component.exports